import AccordionV2Item from "components/AccodianItem";
import "./index.scss";
import wrapperHOC from "@Utils/wrapperHOC";

type AccordianV2Props = {
  data: any;
  CustomAccordionItem?: any;
  className?: string;
  addDivider?: boolean;
  isDesktop?: boolean;
  activeTab?: string;
  sectionClassname?: string;
  dividerClassname?: string;
  dataTestId?: string;
  isPlusCategories?: boolean;
  defaultFirstOpen?: boolean;
};

const AccordionV2 = ({
  data,
  CustomAccordionItem,
  className,
  addDivider,
  isDesktop = false,
  activeTab = "all",
  sectionClassname = "",
  dividerClassname = "",
  isPlusCategories = false,
  defaultFirstOpen = false,
}: AccordianV2Props) => (
  <div className={sectionClassname}>
    {data.map((item: any, index: number) =>
      CustomAccordionItem ? (
        <CustomAccordionItem
          {...(className && { className })}
          key={index}
          index={index}
          {...item}
          isDesktop={isDesktop}
          activeTab={activeTab}
          isLastItem={index === data.length - 1}
          isPlusCategories={isPlusCategories}
          defaultFirstOpen={defaultFirstOpen}
        />
      ) : (
        <AccordionV2Item
          {...(className && { className })}
          key={index}
          title={item.title}
          description={item.description}
          index={index}
          addDivider={addDivider}
          dividerClassname={dividerClassname}
          isLastItem={index === data.length - 1}
          isPlusCategories={isPlusCategories}
        />
      ),
    )}
  </div>
);

export default wrapperHOC(AccordionV2, {
  componentName: "AccordionV2-Global",
  showForChina: true,
});
